module.exports = __webpack_public_path__ + "img/cvlink.425bb569.jpg";